//
import OrdererPriorityModel from '@/models/Warehouse/WhOrdererPriority'
import ProductModel from '@/models/Warehouse/WhProduct'
import ProviderModel from '@/models/Purchase/PchProvider'
import WarehouseModel from '@/models/Warehouse/WhWarehouse'
import UserModel from '@/models/General/GUser'

//
import ProductFilters from '@/views/Warehouse/WhProduct/list/filters'
import ProductHeaders from '@/views/Warehouse/WhProduct/list/headers'
import { required } from '@/services/validations'

//
import headers from './headers'

//
export default ({ g_branch_office_id }) => [
    {
        name: 'g_supervisor_user_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'full_name',
            itemValue: 'id',
            label: 'Responsable',
            model: UserModel,
            noDataText: 'Sin empleados.',
            noObject: true,
            rules: [required],
        },
    },
    {
        name: 'wh_warehouse_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'name',
            itemValue: 'id',
            label: 'Bodega',
            model: WarehouseModel,
            noDataText: 'Sin bodegas.',
            noObject: true,
            paramFilter: {
                //permission: true,
            },
            rules: [required],
        },
        trigger(ctx) {
            //
            const productsFetch = ({ wh_product_id }) =>
                    ProductModel.append('stocks').find(wh_product_id),
                productsList = ctx.value.wh_selected_products,
                warehouse_id = ctx.value.wh_warehouse_id

            //
            Promise.all(productsList.map(productsFetch)).then(products => {
                //
                products.forEach(product => {
                    //
                    const productStock = product.stocks.reduce(
                        (branchStock, branch) => {
                            return (
                                branch.wh_warehouses.reduce(
                                    (warehouseStock, warehouse) => {
                                        return warehouse.wh_warehouse_id ===
                                            warehouse_id
                                            ? warehouseStock +
                                                  (warehouse.logical_stock || 0)
                                            : warehouseStock
                                    },
                                    0
                                ) + branchStock
                            )
                        },
                        0
                    )

                    //
                    const productSelected = ctx.value.wh_selected_products.find(
                        ({ wh_product_id }) => wh_product_id === product.id
                    )

                    //
                    if (productSelected) {
                        productSelected['stock'] = productStock
                    }
                })
            })
        },
    },
    {
        name: 'pch_provider_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemKey: 'id',
            itemText: 'alias_name',
            itemValue: 'id',
            label: 'Proveedor',
            model: ProviderModel,
            noDataText: 'Sin proveedores.',
            noObject: true,
            rules: [required],
        },
        trigger(ctx) {
            //
            const branchField = ctx.getField('pch_provider_branch_offices_id'),
                branchSelected = ctx.value.pch_provider_branch_offices_id,
                providerInput = ctx.getInput('pch_provider_id'),
                providerSelected = providerInput.getSelected()

            //
            branchField.props.items =
                providerSelected.branch_offices ||
                providerSelected.pch_provider_branch_offices ||
                []
            branchField.props.readonly = branchField.props.items.length < 1

            //
            ctx.value.pch_provider_branch_offices_id = 0
            ctx.value.pch_provider_branch_offices_id = branchSelected
        },
    },
    {
        name: 'pch_provider_branch_offices_id',
        type: 'select',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            items: [],
            itemText: 'address',
            itemValue: 'id',
            label: 'Sucursal',
            noDataText: 'Sin sucursales.',
            noObject: true,
            readonly: true,
            rules: [required],
        },
    },
    {
        name: 'wh_orderer_priority_id',
        type: 'autocomplete-model',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            itemText: 'priority',
            itemValue: 'id',
            label: 'Prioridad',
            model: OrdererPriorityModel,
            noDataText: 'Sin prioridades.',
            noObject: true,
            rules: [required],
        },
    },
    {
        name: 'created_at',
        type: 'date-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Creado',
            pickerProps: {
                readonly: true,
            },
        },
    },
    {
        name: 'g_state_name',
        type: 'text-field',
        flex: {
            sm6: true,
            lg3: true,
        },
        props: {
            label: 'Estado',
            readonly: true,
        },
    },
    {
        name: 'wh_selected_products',
        type: 'table-field',
        flex: {
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            headers: headers.product,
            noDataText: 'Sin productos.',
            pickerProps: {
                filters: ProductFilters,
                headers: ProductHeaders,
                noPagination: false,
                mapper: row => {
                    row['g_branch_office_id'] = g_branch_office_id
                    row['quantity'] = 0
                    row['stock'] = row.stock || 0
                    row['wh_product_id'] = row.id
                    return row
                },
                submitText: 'confirmar selección',
                service: ProductModel,
                title: 'Seleccionar producto',
            },
            toolbarTitle: 'Lista de productos incluidos en la orden',
            rules: [required],
        },
    },
    {
        name: 'pch_purchase_orders',
        type: 'table-field',
        flex: {
            'pt-0': true,
            xs12: true,
        },
        props: {
            checkable: true,
            headers: headers.order,
            noDataText: 'Sin ordenes de compra.',
            pickerProps: {
                filters: ProductFilters,
                headers: ProductHeaders,
                noPagination: false,
                submitText: 'confirmar selección',
                service: ProductModel,
                title: 'Seleccionar producto',
            },
            toolbarTitle: 'Lista de ordenes de compra relacionadas con la solicitud de abastecimiento',
            rules: [required],
        },
    },
    {
        name: 'comment',
        type: 'textarea',
        flex: {
            xs12: true,
        },
        props: {
            label: 'Comentario',
        },
    },
]
